import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { fetchActions } from 'actions/actions';
import { media } from 'styles/breakpoints';

// components
import Quote from 'components/Quote/Quote';
import TakeActionList from './TakeActionSection';

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;

  ${media.small`
    max-width: 1440px;
  `};
`;

// TODO: Refactor into shared Header Component
const Header = styled.h1`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  margin: 45px 0;
  text-align: center;
`;

// TODO: Refactor into shared Text Component
const Text = styled.p`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  font-size: 20px;
  line-height: 30px;
  text-align: justify;

  ${media.small`
    margin: 60px 20px;
  `} ${media.medium`
    max-width: 75%;
    margin: 60px auto;
  `};
`;

class TakeAction extends PureComponent {
  static propTypes = {
    actions: ImmutablePropTypes.map
  };

  componentWillMount() {
    const { fetchActions } = this.props;
    fetchActions();
  }

  render() {
    const { actions } = this.props;

    return (
      <Container>
        <Header>Take Action</Header>
        <Text>
          It is easy to get overwhelmed by the sheer magnitude of the chaos our
          country has fallen into and feel powerless to stop it. But the fact of
          the matter is that while Donald Trump is one man, we are millions.
          While Donald Trump runs from Robert Mueller, we are the ones actually
          making this country run. While Donald Trump has the ability to throw
          Twitter tantrums, we still have the ability to throw him out of
          office... if we stick together.
        </Text>
        <Quote
          text={
            "Never doubt that a small group of thoughtful, committed citizens can change the world; indeed, it's the only thing that ever has.\nMargaret Mead"
          }
        />
        <Text>
          Here are 3 things you can do right now to make sure you are part of
          the solution:
        </Text>

        <TakeActionList
          header="Register to vote... and actually show up"
          items={actions.get('default')}
        />

        <TakeActionList
          body={[
            "If there is one thing Donald Trump understands, it's the power of money. We may not have a father to give us a small loan of one million dollars, but that doesn't mean we can't make a difference. Below are a number of charities working to actually make this country great. So when you're not voting with a ballot, vote with your wallet."
          ]}
          header="Donate"
          items={actions.get('charity')}
        />

        <TakeActionList
          body={[
            "Whether you're on the Left or the Right, sane Americans of all political stripes recognize the incredible danger Donald Trump and his enablers pose to our country. We may not all agree on policy, but when it comes to opposing racism, demagoguery, and the general moral decay that follows this president wherever he goes, we should all be united. There weren't actually good people on both sides at Charlottesville, but there are still good people on both sides of the aisle working to stop Trump's agenda of division and hatred.",
            "So if you're a liberal progressive working to flip as many districts from Red to Blue in November, check out some of the sites below for ways you can get involved."
          ]}
          header="Get Involved"
          items={actions.get('leftWing')}
        />

        <TakeActionList
          body={[
            "And if you're a Conservative Republican looking to take your party back from the charlatans, con men, and others who have decided that power is more important than principles, head over to some of the sites below to help kick MAGA out of the GOP."
          ]}
          items={actions.get('rightWing')}
        />
      </Container>
    );
  }
}

export default connect(
  state => ({
    actions: state.getIn(['actions', 'all'])
  }),
  { fetchActions }
)(TakeAction);



// WEBPACK FOOTER //
// ./src/views/TakeAction/TakeAction.js